import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';

export const pendingInviocesGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot
) => {
  const router = inject(Router);
  const requiredParams = 'id'; // Define aquí tus parámetros requeridos

  // Verificamos si todos los parámetros requeridos están presentes en la URL
  console.log(route.queryParamMap);

  const hasParam = route.queryParamMap.has('id');

  if (hasParam) {
    return true; // Si todos los parámetros existen, permite el acceso
  } else {
    console.error('Acceso denegado: Faltan parámetros requeridos en la URL.');
    router.navigate(['seguros/movilidad/motos/cotizador']); // Redirige a la ruta raíz
    return false; // Bloquea el acceso
  }
};
